import { FaWhatsapp, FaPhone, FaLocationDot, FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";

function CtaBanner() {
  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <section className="cta-section w-full h-auto relative overflow-hidden bg-cover bg-center">
      <div className="container page-padding py-14 sm:py-16 md:py-20 text-white relative z-10">
        {/* Top Accent Tag */}
        <span className="inline-block text-[#ffd600] text-[11px] sm:text-[12px] font-extrabold uppercase tracking-[3px] mb-3">
          ⚡ Start Your Journey
        </span>

        {/* Heading */}
        <h2 className="text-[26px] sm:text-[32px] md:text-[40px] font-black leading-tight uppercase">
          Ready to Transform <br className="hidden sm:inline" />
          <span className="text-[#FF0336]">Your Body?</span>
        </h2>

        {/* Contact Info */}
        <h3 className="text-[20px] sm:text-[24px] md:text-[28px] font-extrabold my-3 sm:my-4 flex items-center gap-2 flex-wrap">
          <span className="text-[#FF0336]">Call / WhatsApp:</span>
          <span className="text-white">+91 86374 88702</span>
        </h3>

        {/* Working Hours & Location */}
        <p className="text-[13.5px] sm:text-[15px] text-neutral-300 mb-8 sm:mb-10 max-w-xl font-medium">
          Mon – Sat &nbsp;|&nbsp; 5:00 AM – 10:00 PM &nbsp;|&nbsp; Echanari, Coimbatore
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3.5 sm:gap-4 max-w-2xl">
          {/* WhatsApp Button */}
          <a
            href="https://wa.me/918637488702?text=Hi%2C%20I%20want%20to%20join%20FAT2FIT!"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contact FAT2FIT on WhatsApp"
            className="w-full sm:w-auto bg-[#25D366] text-white font-bold uppercase text-[13px] sm:text-[14px] py-4 px-7 sm:px-8 tracking-wider hover:opacity-90 hover:scale-[1.02] transition-all duration-200 text-center flex items-center justify-center gap-2.5 rounded-xl shadow-lg shadow-green-600/20"
          >
            <FaWhatsapp className="text-[20px] shrink-0" />
            <span>WhatsApp Us</span>
          </a>

          {/* Call Button */}
          <a
            href="tel:+918637488702"
            aria-label="Call FAT2FIT"
            className="w-full sm:w-auto bg-white text-black font-bold uppercase text-[13px] sm:text-[14px] py-4 px-7 sm:px-8 tracking-wider hover:bg-[#FF0336] hover:text-white hover:scale-[1.02] transition-all duration-200 text-center flex items-center justify-center gap-2.5 rounded-xl shadow-lg shadow-white/10"
          >
            <FaPhone className="text-[16px] shrink-0" />
            <span>Call Now</span>
          </a>

          {/* Visit Us Button */}
          <Link
            onClick={goTop}
            to="/contact"
            aria-label="Visit FAT2FIT contact page"
            className="w-full sm:w-auto bg-[#FF0336] text-white font-bold uppercase text-[13px] sm:text-[14px] py-4 px-7 sm:px-8 tracking-wider hover:bg-black hover:scale-[1.02] transition-all duration-200 text-center flex items-center justify-center gap-2.5 rounded-xl shadow-lg shadow-red-600/20"
          >
            <FaLocationDot className="text-[16px] shrink-0" />
            <span>Visit Us</span>
            <FaArrowRight className="text-[13px] shrink-0" />
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CtaBanner;